module.exports = __webpack_public_path__ + "static/media/install03.9bd9c851.png";